import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { SearchService } from '../../../services/search.service';
import { UIDataService } from '../../../../modules/customer-care/services/uidata.service';
import { DataService } from '../../../services/data.service';
import { UIBaseService } from '../../../services/uibase.service';
import { Header } from '../../../models/header.model';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LanguageService } from '../../../services/language-service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'cop-searchpage-header',
  templateUrl: './searchpage-header.component.html',
  styleUrls: ['./searchpage-header.component.scss'],
  standalone: false
})
export class SearchpageHeaderComponent implements OnInit {
  RequestedURL = ''
  showMenu = false;
  filterInput: any;
  header!: Header;
  firstName!: string;
  lastName!: string;
  userType!: string;
  userInfo: any;

  pollingData: any;
  status: boolean = false;
  showDropHide: boolean = false;
  searchResponse: any;
  searchStr: any;
  // showHideSearch: boolean = false;
  publicHeaderlink: any;
  originUrl!: string;
  isAvayaCloudOffice: boolean = false;
  isSearchPage: boolean = false;
  isAvayaCCass: boolean = false;
  infoMenu: boolean = false;
  langDropdown: boolean = false;
  enUrl: string = "";
  frUrl: string = "";
  ringSSoSession: any;
  hideListMenus: boolean = false;
  sinInLink: any;
  isSearchOpen: boolean = false;
  checkingDown: any;
  viewId: any;
  initialDefaultDropdown: any;
  environmentUrlIslocal: boolean = false;
  // defaultSettingIcon!: boolean;
  // viewSettingIcon: boolean = false;
  logout: any;
  localLangCode: string = "";
  isMobView: boolean = false;
  leftMenusPublic: any[] = [];
  rightMenusPublic: any[] = [];
  leftMenus: any[] = [];
  rightMenus: any[] = [];
  isNoPublicLeftMenus: boolean = false;
  isNoLeftMenus: boolean = false;

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      if(window.innerWidth < 768)
        this.isMobView = true;
      else
        this.isMobView = false;
    }

  constructor(
    private uibase: UIBaseService,
    private ds: DataService,
    private ui: UIDataService,
    private el: ElementRef,
    private searchservice: SearchService,
    private languageService: LanguageService
  ) { }

  ngOnInit() {
    this.localLangCode = this.languageService.localCode;

    if(window.innerWidth < 768)
      this.isMobView = true;
    else
      this.isMobView = false;

    this.logout = window.location.origin + "/customercare" + this.localLangCode + environment.sso_signout;

    this.originUrl = window.location.origin + "/customercare" + this.localLangCode + "/public";
    if (window.location.href.indexOf("AvayaCloudOffice") > -1) {
      this.isAvayaCloudOffice = true;
    }
    if (window.location.href.indexOf("search") > -1) {
      this.isSearchPage = true;
    }
    if (window.location.href.indexOf("AvayaCCaaS") > -1 || window.location.href.indexOf("AvayaOneCloudCCaaS") > -1) {
      this.isAvayaCCass = true;
    }
    const currentUrl = window.location.href;
    const spiltUrl = currentUrl.slice(0, currentUrl.indexOf('.com') + 4);
    if (this.isAvayaCloudOffice) {
      this.enUrl = spiltUrl + "/AvayaCloudOffice";
      this.frUrl = spiltUrl + "/fr/AvayaCloudOffice";
    }

    this.ds.ringSso.subscribe(profile => {
      this.ringSSoSession = profile;
    });

    this.filterInput = this.ui;
    this.publicHeaderlink = this.filterInput.uibase.pageHeader.headerLinks;
    this.publicHeaderlink.forEach((element: any) => {
      if (element.HasSubHeaderLink && element.HasSubHeaderLink === "true")
        element.HasSubHeaderLink = true;
      else
        element.HasSubHeaderLink = false;

      if (element.alttext == "signin") {
        this.sinInLink = element;
      }
      if (element.alttext === "language") {
        (element.SubHeaderLinks && element.SubHeaderLinks.length) && element.SubHeaderLinks.forEach((link: any) => {
          link["isSelectedLang"] = false;

          if (this.localLangCode.includes("en") && (link.alttext === "English"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("de") && (link.alttext === "Deutsch"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("nl") && (link.alttext === "Dutch"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("fr") && (link.alttext === "French"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("it") && (link.alttext === "Italian"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("es") && (link.alttext === "Espanol"))
            link.isSelectedLang = true;
          else
            link.isSelectedLang = false;
        });
      }

    });
    const separatorIdxPublic = this.publicHeaderlink.findIndex((obj: any) => obj.alttext === "Header-Separator");
    this.leftMenusPublic = this.publicHeaderlink.slice(0, separatorIdxPublic);
    this.isNoPublicLeftMenus = (this.leftMenusPublic.length === 0);
    this.rightMenusPublic = this.publicHeaderlink.slice(separatorIdxPublic + 1);
    this.rightMenusPublic.sort((a: any, b: any) => (a.alttext === 'signin' ? 1 : b.alttext === 'signin' ? -1 : 0)); // just to shift signin object at end of an array

    this.header = new Header(
      this.uibase.pageHeader['logo'],
      this.uibase.pageHeader['headerLinks'],
      this.uibase.pageHeader['usersettings']
    );

    (this.header._headerlinks as any[]).forEach((elem: any) => {
      if (elem.HasSubHeaderLink && elem.HasSubHeaderLink === "true")
        elem.HasSubHeaderLink = true;
      else
        elem.HasSubHeaderLink = false;

      if (elem.alttext === "language") {
        (elem.SubHeaderLinks && elem.SubHeaderLinks.length) && elem.SubHeaderLinks.forEach((link: any) => {
          link["isSelectedLang"] = false;

          if (this.localLangCode.includes("en") && (link.alttext === "English"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("de") && (link.alttext === "Deutsch"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("nl") && (link.alttext === "Dutch"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("fr") && (link.alttext === "French"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("it") && (link.alttext === "Italian"))
            link.isSelectedLang = true;
          else if (this.localLangCode.includes("es") && (link.alttext === "Espanol"))
            link.isSelectedLang = true;
          else
            link.isSelectedLang = false;
        });
      }
    });

    const separatorIdx = (this.header._headerlinks as any[]).findIndex((obj: any) => obj.alttext === "Header-Separator");
    this.leftMenus = (this.header._headerlinks as any[]).slice(0, separatorIdx);
    this.isNoLeftMenus = (this.leftMenus.length === 0);
    this.rightMenus = (this.header._headerlinks as any[]).slice(separatorIdx + 1);
    this.rightMenus.sort((a: any, b: any) => (a.alttext === 'signin' ? 1 : b.alttext === 'signin' ? -1 : 0)); // just to shift signin object at end of an array

    this.firstName = this.uibase.userInfo.First_Name;
    this.lastName = this.uibase.userInfo.Last_Name;
    this.userInfo = this.uibase.userInfo;
    this.userType = this.uibase.userInfo.usertype;

    if (this.userInfo.usertype && this.userInfo.usertype != 'Public')
      this.originUrl = window.location.origin + "/customercare" + this.localLangCode + "/home";
  }

  clickEvent() {
    this.status = !this.status;
  }
  closeMenuItems() {
    let dropdowns = this.el.nativeElement.querySelectorAll(".menu-dropdown,.menuList,.user-dropdown");
    for (let i = 0; i < dropdowns.length; i++) {

      dropdowns[i].classList.remove('open');
      let arrowIcons = dropdowns[i].querySelectorAll('.rotate,.active')
      arrowIcons.forEach(function (icon) {
        icon.classList.remove('rotate')
        icon.classList.remove('active')
      });
      dropdowns[i].classList.remove('active');
    }
  }

  openLanguageDropdown() {
    this.langDropdown = true;
  }

  closeLanguageDropdown() {
    this.langDropdown = false;
  }

  toggleMobileview() {
    this.showMenu = !this.showMenu;
  }

  linkTarget(link, targetType) {
    if (!link.HasSubHeaderLink) {
      window.open(link.url, targetType);
    }
  }

  onLoginEventFired(event, searchStr) {
    this.showDropHide = true;
    let autoFillUrl = '/cs/Satellite?pagename=OCP/Search/getSuggestions&q=' + searchStr + '&client=test_frontend&site=default_collection&format=os';
    this.ds.getSearchResults(autoFillUrl)
      .pipe(
        catchError(val => of(`ERROR sending data ${val}`))
      )
      .subscribe(resp => {
        this.searchResponse = resp;
      });

    if ((event.key == 'Enter' || event.which === 1)) {
      // this.showHideSearch = !this.showHideSearch;
      this.searchservice.setSearchTerm(searchStr);
      this.searchservice.setSearchResultsPageStatus(false);
      this.searchStr = '';
    }
  }

  // headSearch() {
  //   this.showHideSearch = !this.showHideSearch;
  //   this.showDropHide = false;
  // }

  revokeSsoSesion() {
    let url = "revokeToken";
    const formData = new FormData();
    formData.append("Token", this.ringSSoSession.accessToken);

    this.ds.getITSSToken().subscribe((res: any) => {
      if (res && res.token) {
        this.ds.publicPostData(url, formData, res.token)
          .pipe(
            switchMap((resp: any) => {
              return of(resp);
            }))
          .subscribe(data => {
            this.ds.getRingSessionData(null);
            localStorage.removeItem('ringUser');
            // this.cookieService.delete("RINGSESSIONID");
            // this.cookieService.delete("RINGSESSION");
            // this.cookieService.delete("RINGSESSIONTIME");
            window.location.reload();
          });
      } else {
        console.error("iTSs token fetch failed", res);
      }
    });
  }

  OpenRequestsView(type) {
    let acoUrl = window.location.href;
    let index = acoUrl.indexOf('?');
    this.isSearchOpen = true;
    this.ui.openRequestsTab.next(type);
    this.ui.openSearchView.next(false);

    if (type == 'my') {
      this.RequestedURL = acoUrl = acoUrl.slice(0, index) + "/myrequests?" + acoUrl.slice(acoUrl.indexOf('view='), acoUrl.length);
    } else if (type == 'history') {
      this.RequestedURL = acoUrl = acoUrl.slice(0, index) + "/history?" + acoUrl.slice(acoUrl.indexOf('view='), acoUrl.length);
    }
    setTimeout(() => {
      // let myWindow = window as any;
      // myWindow.sendObjectToChatBot({hosting_url:this.RequestedURL})
      this.closeProfileDropdown();
      this.closeMenuItems();
    }, 1000);
  }

  closeProfileDropdown() {
    this.infoMenu = false;
    // this.defaultSettingIcon = false;
    // this.viewSettingIcon = false;
    this.hideListMenus = false;
    let dropdowns = this.el.nativeElement.querySelectorAll(".cop-prof");
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].classList.remove('open');
      dropdowns[i].classList.remove('active');
    }
  }

  // callMyProfileService() {
  //   this.checkingDown = this.views.forEach(defaultview => {
  //     if (defaultview.defaultview) {
  //       this.viewId = defaultview.id;
  //       this.initialDefaultDropdown = defaultview.id;
  //     }
  //   })
  //   let url = "/customercare/en/home/user?action=add&viewid=" + this.viewId;

  //   this.ds.getData(url)
  //     .pipe(catchError(val => of(`ERROR sending data ${val}`)))
  //     .subscribe(resp => {
  //     });
  // }

  openProfileDropdown() {
    this.infoMenu = true;
    // this.callMyProfileService();
  }

  doNothing() {
    return;
  }

  openSearchView() {
    this.isSearchOpen = false;
    this.ui.openSearchView.next(true);
    this.ui.openRequestsTab.next("");
  }

  onLogout() {
    localStorage.clear();
    sessionStorage.clear();
  }

  ngOnDestroy() {
    if (this.pollingData) {
      this.pollingData.unsubscribe();
    }
  }
}
